// import C$167:7916$ from "F$167:7916$";
import TypePlaceSensitivtyVariant4 from "./TypePlaceSensitivtyVariant4";

const CardVerticalEvent = () => {

  return (
    <div className="self-stretch flex-1 rounded-3xl bg-light overflow-hidden flex flex-col items-center justify-start gap-[16px] text-left text-xs text-dark font-footnote border-b-[4px] border-solid border-lavender sm:hidden">
      <img className="self-stretch relative max-w-full overflow-hidden h-[233px] shrink-0 object-cover" alt="" src="/urlimage2@2x.png" />
      <div className="self-stretch flex flex-col pt-4 px-4 pb-8 items-start justify-start gap-[32px]">
        <div className="self-stretch flex flex-row items-start justify-start">
          <div className="flex-1 flex flex-col items-start justify-start gap-[16px]">
            <div className="self-stretch flex flex-row items-start justify-start gap-[16px] text-5xl">
              <img className="relative rounded-11xl w-11 h-11 object-cover" alt="" src="/rectangle-20@2x.png" />
              <b className="flex-1 relative">Adult Autism Basketball</b>
            </div>
            <div className="self-stretch flex flex-row pt-0 px-0 pb-2 items-center justify-start gap-[4px] border-b-[1px] border-solid border-darkslategray-200">
              <div className="bg-lavender flex flex-row items-center justify-start">
                <b className="relative">Event</b>
              </div>
              <div className="relative rounded-[50%] bg-dark w-1 h-1" />
              <div className="relative">8/5 @3:30 ET</div>
              <div className="relative rounded-[50%] bg-dark w-1 h-1" />
              <div className="relative">134 1st Ave, New York, NY</div>
            </div>
            <b className="relative">Good for the following sensitivities</b>
            <div className="self-stretch flex flex-row flex-wrap items-start justify-start gap-[6px] text-sm font-h2-accent">
              <div className="rounded bg-lavender hidden flex-row p-2.5 items-center justify-center gap-[10px]">
                <img className="relative w-6 h-6" alt="" src="/icon-set11.svg" />
                <div className="relative font-medium">Lifestyle</div>
              </div>
              <div className="rounded bg-lavender hidden flex-row p-2.5 items-center justify-center gap-[10px]">
                <img className="relative w-6 h-6" alt="" src="/icon-set1.svg" />
                <div className="relative font-medium">Taste</div>
              </div><TypePlaceSensitivtyVariant4 iconSet="/icon-set14.svg" lifestyle="Crowd" typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5dbff" iconSetOverflow="unset" iconSetFlexShrink="unset" /><TypePlaceSensitivtyVariant4 iconSet="/icon-set12.svg" lifestyle="Motor Skills" typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5dbff" iconSetOverflow="unset" iconSetFlexShrink="unset" />
              <div className="rounded bg-lavender hidden flex-row p-2.5 items-center justify-center gap-[10px]">
                <img className="relative w-6 h-6" alt="" src="/icon-set4.svg" />
                <div className="relative font-medium">Orderliness</div>
              </div><TypePlaceSensitivtyVariant4 iconSet="/icon-set11.svg" lifestyle="Lifestyle" typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5dbff" iconSetOverflow="unset" iconSetFlexShrink="unset" />
              <div className="rounded bg-lavender hidden flex-row p-2.5 items-center justify-center gap-[10px]">
                <img className="relative w-6 h-6" alt="" src="/icon-set2.svg" />
                <div className="relative font-medium">{`Visual `}</div>
              </div>
              <div className="rounded bg-lavender hidden flex-row p-2.5 items-center justify-center gap-[10px]">
                <img className="relative w-6 h-6" alt="" src="/icon-set2.svg" />
                <div className="relative font-medium">{`Visual `}</div>
              </div>
              <div className="rounded bg-lavender hidden flex-row p-2.5 items-center justify-center gap-[10px]">
                <img className="relative w-6 h-6" alt="" src="/icon-set2.svg" />
                <div className="relative font-medium">{`Visual `}</div>
              </div>
              <div className="rounded bg-lavender hidden flex-row p-2.5 items-center justify-center gap-[10px]">
                <img className="relative w-6 h-6" alt="" src="/icon-set2.svg" />
                <div className="relative font-medium">{`Visual `}</div>
              </div>
              <div className="rounded bg-lavender hidden flex-row p-2.5 items-center justify-center gap-[10px]">
                <img className="relative w-6 h-6" alt="" src="/icon-set2.svg" />
                <div className="relative font-medium">{`Visual `}</div>
              </div>
              <div className="rounded bg-lavender hidden flex-row p-2.5 items-center justify-center gap-[10px]">
                <img className="relative w-6 h-6" alt="" src="/icon-set2.svg" />
                <div className="relative font-medium">{`Visual `}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="self-stretch flex flex-row py-0 pr-0 pl-4 items-start justify-start text-xl font-h2-accent border-l-[4px] border-solid border-lavender">
          <div className="flex-1 relative font-medium">“The autism alliance reserved the basketball courts at Chelsea Piers for autistic adults to learn basketball, make friends, and socialize in a safe space.”</div>
        </div>
      </div>
    </div>);
};

export default CardVerticalEvent;
